import React, { useEffect } from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { Container } from 'reactstrap';
import { observer } from 'mobx-react';
import CompanyDetailsContainer from './CompanyDetails';
import { useStores } from '../../hooks/use-stores';
import PartnerSettings from './PartnerSettings';
import PartnerAppearance from './PartnerAppearance';
import PartnerContent from './PartnerContent';
import PartnerRoute from '../../hocs/PartnerRoute';

const Partner = () => {
    const { authStore, partnerStore } = useStores();
    const location = useLocation();
    let partner = authStore.currentUser.superForAccounts[0];

    useEffect(() => {
        const isCompanyDetailsRoute = /\/partner\/\d+\/companies\/\d+/.test(location.pathname);
        
        if (!isCompanyDetailsRoute && partnerStore.editingCompany) {
            partnerStore.clearEditingCompany();
        }

        return () => {
            if (partnerStore.editingCompany) {
                partnerStore.clearEditingCompany();
            }
        };
    }, [location.pathname, partnerStore]);

    return (
        <Routes>
            <Route
                path="/"
                element={
                    <Navigate to={partner.id + '/companies'} replace={true} />
                }
            />
            <Route
                path=":partnerId"
                element={<Navigate to={'companies'} replace={true} />}
            />

            <Route
                path=":partnerId/companies/:companyId"
                element={<PartnerRoute><CompanyDetailsContainer /></PartnerRoute>}
            />

            <Route
                path=":partnerId/settings/appearance"
                element={<PartnerRoute><PartnerAppearance /></PartnerRoute>}
            />

            <Route
                path=":partnerId/content/*"
                element={
                    <PartnerRoute>
                        <Container className="manager-content campaigns wide">
                            <PartnerContent />
                        </Container>
                    </PartnerRoute>
                }
            />

            <Route
                path=":partnerId/*"
                element={<PartnerRoute><PartnerSettings /></PartnerRoute>}
            />
        </Routes>
    );
};

export default observer(Partner);
